import type { Module } from 'vuex'
import { insightActions } from './actions'
import type { InsightState } from './types'
import type { RootState } from '@/store/modules/types'
import { clone } from '@/utils/helpers'
import type { Insights } from '@/types/resources/insights'

export const initialInsightStates = (): InsightState => ({
  currentInsights: null,
  isPollingCurrentInsights: false,
  fetchInsightsPolling: null,
  hasFetchInsightsFailed: false,
})

const insightModule: Module<InsightState, RootState> = {
  namespaced: true,
  state: initialInsightStates,
  actions: insightActions,
  mutations: {
    RESET_CURRENT_INSIGHTS(state) {
      console.log('Resetting current insights')
      state.currentInsights = null
    },
    SET_CURRENT_INSIGHTS(state, insight: Insights) {
      console.log('Setting insights data:', insight ? 'has data' : 'no data')
      state.currentInsights = clone(insight)
    },
    SET_IS_POLLING_CURRENT_INSIGHTS(state, isFetching: boolean) {
      console.log('Setting polling status:', isFetching)
      state.isPollingCurrentInsights = isFetching
    },
    RESET_FETCH_INSIGHTS_POLLING(state) {
      console.log('Resetting insights polling')
      state.fetchInsightsPolling = null
    },
    SET_FETCH_INSIGHTS_POLLING(state, timeout: NodeJS.Timeout) {
      console.log('Setting insights polling timeout')
      state.fetchInsightsPolling = timeout
    },
    SET_HAS_FETCH_INSIGHTS_FAILED(state, hasFailed: boolean) {
      console.log('Setting fetch insights failed:', hasFailed)
      state.hasFetchInsightsFailed = hasFailed
    },
  },
  getters: {
  },
}

export default insightModule
